import { useErrors } from '../../hooks/useErrors';
import { useState } from 'react';
import { ApiOrder } from '../../types';
import { AddressModalInput } from './AddressModalInput';
import { EditAddressModal } from './EditAddressModal';
import { phonePattern } from '../../components/Form/FormValidatorContainer';

type DeliveryAddressFields = 'company' | 'street' | 'zip' | 'city' | 'firstname' | 'lastname' | 'phone';

const REQUIRED_FIELDS = ['company', 'firstname', 'lastname', 'street', 'zip', 'city', 'phone'];
const PHONE_PATTERN_FIELDS = ['phone'];

export const EditDeliveryAddressModal = ({
	invoiceAddress,
	setInvoiceAddress,
}: {
	invoiceAddress: ApiOrder['delivery'];
	setInvoiceAddress: (address: ApiOrder['delivery']) => void;
}) => {
	const [address, setAddress] = useState(invoiceAddress);
	const { errors, setErrors, validate } = useErrors();

	const handleChange = (e: { target: { name: string; value: string } }) => {
		setAddress((prev) => ({ ...prev, [e.target.name]: e.target.value }));

		const key = e.target.name as DeliveryAddressFields;

		validate(e.target.value, key, {
			required: REQUIRED_FIELDS.includes(key),
			pattern: PHONE_PATTERN_FIELDS.includes(key) ? phonePattern : '',
		});
	};

	const onBlur = () => {
		setErrors({});

		for (const field of Object.keys(address)) {
			const key = field as DeliveryAddressFields;

			validate(address[key], key, { required: REQUIRED_FIELDS.includes(key) });
		}
	};

	return (
		<EditAddressModal
			onSave={() => {
				setInvoiceAddress(address);
			}}
			disabled={Object.values(errors)
				.map(({ valid }) => valid)
				.some((valid) => !valid)}
		>
			<div className="edit-address-content-main">
				{(Object.keys(address) as DeliveryAddressFields[]).map((field: DeliveryAddressFields) => {
					return (
						<AddressModalInput
							key={field}
							name={field}
							value={address[field]}
							errors={errors}
							onChange={handleChange}
							onBlur={onBlur}
						/>
					);
				})}
			</div>
		</EditAddressModal>
	);
};
